<template>
	<section>
		<compSteplist :status="getStatus" :progressStatus="getProgressStatus" style="margin-left:290px"></compSteplist>
        <!-- 按钮展示 -->
        <div class="margin-bottom-10">
            <vButton v-if="formData.status === 5 || formData.status === 0" class="margin-right-10" theme="success" @click="complateBill">处理完成</vButton>
            <vButton v-if="formData.errorStatus !== 99999" class="margin-right-10" theme="info" @click="rehandle">重处理</vButton>
            <vButton v-if="formData.errorStatus !== 99999" class="margin-right-10" theme="gray" @click="ignoreAbnormal">忽略异常</vButton>
            <vButton v-if="formData.status === 0" class="margin-right-10" theme="info" @click="rePush">重推仓库</vButton>
            <vButton v-if="!isActive" style="position:absolute;right:10px" theme="default" @click="cancel">返回</vButton>
        </div>
		<compWrapper title="基本信息" theme="primary">
			<compFormQuery class="margin-layout" :formdata="getBase" :value="formData" placeholder="--"></compFormQuery>
		</compWrapper>
		<compWrapper title="产品信息" theme="success">
			<vTableSimple class="margin-layout" :data="productList" :columns="getCusproductColumns"></vTableSimple>
		</compWrapper>
        <compWrapper :title="$t('global.common.attache',{defaultValue:'附件信息'})" theme="info">
			<compAttach
				class="margin-layout"
				ref="attachlist"
				:data="attachList"
				:activeid="id"
                :formData="formData"
				@on-update="getDetail"
			></compAttach>
		</compWrapper>
		<compLog wrapper :data="logList"></compLog>
		<vLoading size="large" transfer :loading="loading"></vLoading>
        <compModal
			v-model="modalProps.show"
			v-bind="modalProps"
            @on-close="closemodalprops"
		>
            <component ref="cusref" :is="modalProps.component"  v-bind="modalProps" @on-close="closemodalprops" v-on="modalProps.on"></component>
        </compModal>
	</section>
</template>

<script>
import { HttpReturnProcessPlanDetail, HttpReturnProcessPlanReprocess, HttpReturnProcessPlanIgnoreError, HttpReturnProcessPlanRepushWareHouse, HttpCheckProcessDetail, HttpReturnProcessPlanComplete } from '@/service/salesreturns';
import mixin from "../mixin";
import { mapGetters } from 'vuex';
import compAttach from './attach';
import compHandleWay from './handlephoto.vue';
import compSteplist from '../steplist';
import compPhoto from '../photo.vue'

export default {
	mixins: [mixin],
    props:['activeids'],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		// compFormEdit: () => import("@components/templates/formedit"),
		compLog: () => import("@components/templates/log"),
		compModal: () => import("@components/templates/modal"),
        compAttach,
        compHandleWay,
        compSteplist,
        compPhoto
	},
	data() {
		return {
			loading: false,
			id: this.$route.query.id || this.activeids,
			formData: {},
            isActive: this.activeids ? true : false,
			productList: [],
			logList: [],
			modalProps: {
				show: false,
			},
			attachList: [],//附件列表
		};
	},
	created() {
		this.getDetail();
	},
	computed: {
        ...mapGetters('dictionary', ['getSelfmanageorgList', 'getCusproductList','getUserManageWarehouseList', 'getBillcusWareList']),
		/**
		 * 根据状态显示不同按钮
		 */
		// getStatusBtns() {
		// 	const status = this.formData.saleReturnPlanStatus;
		// 	const btn = [{
		// 		name: '审核',
		// 		theme: 'success',
		// 		show: status == 5,
		// 		run: this.approve && this.handleAuth('fbb.returnplan.review')
		// 	}]
		// 	return btn.filter(item => item.show);
		// },
		getBase() {
			return [{
				label: "退货处理计划单号",
				// key: "saleReturnPlanNo",
                render: ()=>{
                    return <div>
                        <span>{this.formData.returnProcessPlanOrderNo}</span>
                        <span style="margin-left:10px;color:red;">{this.findRenderLabel(this.getErrorSimpleType, this.formData.errorStatus)}</span>
                    </div>
                }
				// query: true,
			},
            {
				label: "处理状态",
				key: "status",
				options: this.getSalesHandlePlanManageOrderStatus,
                render: ( h ) => {
                    const status = this.formData.status;
                    const { label = '', theme} = this.getSalesHandlePlanManageOrderStatus.find(function (item) {
                        return item.value == status
                    }) || {};
                    return <vButton ghost theme={theme} size="small" class="cursor-default">{label || '--'}</vButton>
                }
				// query: true,
			},
			{
				label: "退货仓库",
				key: "orgWarehouseCode",
                render:(h)=>{
                    const wareHouse=this.getUserManageWarehouseList.filter(item=>item.attach.code === this.formData.orgWarehouseCode)
                    return <div>{ wareHouse[0] ? wareHouse[0].label : '--'}</div>
                }
				// tag: "vSelect",
				// options: this.getBillcusWareList,
			},
			{
				label: "项目",
				key: "lineId",
				// tag: "vSelect",
				options: this.getCusproductList,
				// required: false,
				// props: {
				// 	filterable: true
				// },
			},
			{
				label: "退货计划单号",
				key: "saleReturnPlanNo",
			},
			{
				label: "承运商",
				key: "carrierCode",
			},
			{
				label: "退货Tracking",
				key: "returnTrackingNo",
			},
            {   label: this.$t('fbb.alloment.client_organization',{defaultValue:'客户'}),
                key: 'organizationId',
                options: this.getSelfmanageorgList,
            }];
		},
		getCusproductColumns() {
            return[
                {
                    title: 'No',
                    type: 'index',
                    width: 60
                },
                {
                    title: 'SKU',
                    key: 'sku'
                },
                {
                    title: '计划数量',
                    key:'qty'
                },
                {
                    title: '已处理数量',
                    key:'qtyDone'
                },
                {
                    title: '照片',
                    render: (h, {row})=>{
                        let img = [];
                        if(row.picturesUrls){
                            // row.picturesUrl.map(item => {
                            //     img.push(
                            //         <div style="float: left; cursor: pointer; margin-right: 10px;" onClick={this.handleImgModal.bind(this, item)}>
                            //             <img style="width: 50px; height: 50px;" src={item} />
                            //         </div>
                            //     )
                            // });
                            row.picturesUrls.map((item, index) => {
                                let newUrl = item + '?image_process=image/resize,w_100&x-oss-process=image/resize,w_100'
                                img.push(
                                    <div style="float: left; cursor: pointer; margin-right: 10px;" onClick={this.handleImgModal.bind(this, {url: index, urlList: row.picturesUrls})}>
                                        <img style="width: 50px; height: 50px;" src={newUrl} />
                                    </div>
                                )
                            });
                        }
                        else{
                            img = '--'
                        }
                        return (
                            <div style="padding: 10px 0; overflow: hidden;">
                                {img}
                            </div>
                        );
                    }
                },
                {
                    title: '建议处理方式/更换后SKU',
                    render:(h,{row})=>{
                        return <div>
                            <div>{ this.findRenderLabel(this.getHandleType, row.goodsReturnType)|| '--' }</div>
                            <div>{ row.newSku || '--' }</div>
                        </div>
                    }
                },
                {
                    title: '处理备注',
                    render: (h,{row})=>{
                        return row.remark || '--'
                    }
                },
                {
                    title: "操作",
                    width: 120,
                    render: (h,{row})=>{
                        return row.qtyDone == row.qty ? '--' : h('vButton', {
                            props: {
                                theme: 'primary',
                            },
                            nativeOn: {
                                click: this.handlePhoto.bind(this,row)
                            }
                        }, "处理")
                    }
                },
                {
                    title: '更新时间',
                    key:'updatedAt'
                },
            ]
		},
        getStatus() {
			return this.type !== 'add' && this.formData.status
		},
        getProgressStatus() {
            const arr = [
                {
                    name: this.$tc('fbb.sales.sales_status', 1, { defaultValue: '待处理' }),
                    value: '0',
                },
                {
                    name: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '处理中' }),
                    value: '5',
                },
                {
                    name: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '已处理' }),
                    value: '10',
                }]
			return arr
        }
    },
	methods: {
        handleImgModal (obj) {
            this.$emit('on-closeCloseable');
            this.modalProps = {
                show: true,
                title: this.$t('global.photo.info', { defaultValue: '照片信息' }),
                component: "compPhoto",
                currentUrl: obj.url,
                urlList: obj.urlList,
                showFooter: false,
                width: 1200,
                // url: url,
            }
        },
        closemodalprops(){
            this.$emit('on-openCloseable');
            this.modalProps = {};
        },
		//获取计划单详情
		getDetail() {
			this.loading = true;
			HttpReturnProcessPlanDetail({ id: this.id }).then(res => {
				const data = res.data || {};
				this.formData = data.returnProcessPlanOrderEntity;
				this.productList = data.returnProcessPlanOrderItemList;
				this.logList = data.opLogEntityList;
                this.attachList = data.orderAttachesList;
				this.loading = false;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(this.$t(err.langCode, { defaultValue: err.message }));
			})
		},
        // 产品信息处理
        handlePhoto(obj){
            this.$emit('on-closeCloseable');
            this.modalProps = {
				show: true,
				title: "退货处理",
				component: "compHandleWay",
                showFooter:false,
				alert: "primary",
				width: 800,
				showDesc: false,
				params: { obj },
                on: {
					"on-success": () => {
						this.modalProps = {};
                        this.getDetail()
					},
				}
			}
        },
		//完成
		complateBill() {
            this.$emit('on-closeCloseable');
			this.modalProps = {
				show: true,
				title: "完成",
				alert: "success",
				width: "middle",
				params: { id: this.id },
				ajaxRequest: HttpReturnProcessPlanComplete,
				formdata: [
					{
						tag: "vTextarea",
						key: "remark",
						labelWidth: 'auto',
						span: 24,
						label: "备注",
                        required:false,
					}
				],
			}
		},
        // 重处理
        rehandle(){
            this.$emit('on-closeCloseable');
            this.modalProps = {
				show: true,
				title: "重处理",
				alert: "error",
				showDesc: true,
				params: { id: this.id },
				ajaxRequest: HttpReturnProcessPlanReprocess,
			}
        },
        // 忽略异常
        ignoreAbnormal(){
            this.$emit('on-closeCloseable');
            this.modalProps = {
				show: true,
				title: "忽略异常",
				alert: "error",
				showDesc: true,
				params: { id: this.id },
				ajaxRequest: HttpReturnProcessPlanIgnoreError,
			}
        },
        // 重推仓库
        rePush(){
            this.$emit('on-closeCloseable');
            this.modalProps = {
				show: true,
				title: "重推仓库",
				alert: "error",
				showDesc: true,
				params: { id: this.id },
				ajaxRequest: HttpReturnProcessPlanRepushWareHouse,
			}
        },
		cancel() {
			this.$router.push({
				name: 'salesHandlePlanManage'
			})
		}
	}
};
</script>
